import { is } from 'ramda';
import api from "../../utils/api";

export default {
  INFO: {
    GET: hotelsInfos => {
      if (is(Number, hotelsInfos)) {
        hotelsInfos = { hotels: [{ id: hotelsInfos.toString() }] };
      }

      return hotelsInfos;
    },
    GET_ASYNC: (hotelCode) => (dispatch, getState) => {
      return api.get({
        path: `hotel_id?q=hotel_code:${hotelCode}`
      })
      .then(hotelIdResponse => {
        return hotelIdResponse;
      })
      .catch(error => {
        return Promise.reject({ error: "error" });
      });
    }
  }
};
